<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑职工</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">登录账号</div>
                        <el-input v-model="edit_loginName" placeholder="请输入登录账号" disabled></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">选择角色</div>
                        <el-select v-model="edit_roleCode" placeholder="选择角色" @change="changeRole" style="width:100%">
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.roleCode"
                                    :label="item.name"
                                    :value="item.roleCode">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">姓名</div>
                        <el-input v-model="edit_realName" placeholder="请输入姓名"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">手机</div>
                        <el-input v-model="edit_phone" placeholder="请输入手机"></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">职工状态</div>
                        <el-select v-model="edit_status" placeholder="选择状态" @change="changeStatus" style="margin-right: 20px">
                            <el-option
                                    v-for="item in status2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">选择机构</div>
                        <el-select v-model="edit_institutionCode" placeholder="选择机构" @change="changeInstitution" style="width:100%">
                            <el-option
                                    v-for="item in institutionList"
                                    :key="item.institutionCode"
                                    :label="item.name"
                                    :value="item.institutionCode">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Edit',
        props: [],
        data() {
            return {

                loading: false,

                edit_loginName:'',
                edit_realName:'',
                edit_roleCode:'',
                edit_phone:'',
                edit_staffCode:'',
                edit_institutionCode:'',
                edit_isChain:'0',

                roleList:null,
                institutionList:null,

                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                edit_status: 0,

                chainTypes: [{
                    value: 'parent',
                    label: '总机构'
                }, {
                    value: 'middle',
                    label: '中间机构'
                }, {
                    value: 'son',
                    label: '分机构'
                }],
                edit_chainType: 'parent',

            }
        },
        methods: {
            init(row){
                console.log("Edit init");

                this.edit_loginName = row.loginName;
                this.edit_realName = row.realName;
                this.edit_roleCode = row.roleCode;
                this.edit_phone = row.phone;
                this.edit_status = row.status;
                this.edit_staffCode = row.staffCode;
                this.edit_institutionCode = row.institutionCode;

                this.edit_isChain = row.isChain;
                this.edit_chainType = row.chainType;

                this.getRoleList();
                this.getInstitutionList();

            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(){


                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }


                if(this.edit_loginName == ''){
                    return;
                }
                if(this.edit_roleCode == ''){
                    return;
                }
                if(this.edit_realName == ''){
                    return;
                }
                if(this.edit_phone == ''){
                    return;
                }


                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Staff/Edit',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),

                        loginName: this.edit_loginName,
                        realName:this.edit_realName,
                        roleCode:this.edit_roleCode,
                        phone:this.edit_phone,
                        status:this.edit_status,
                        institutionCode:this.edit_institutionCode,

                        staffCode2:this.edit_staffCode,

                    }
                }).then( (response)=> {
                    console.log(response);
                    this.loading = false;

                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                    }else{
                        this.$message(response.data.Message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },


            changeRole:function(selVal){
                this.edit_roleCode = selVal;
            },
            changeInstitution:function(selVal){
                this.edit_institutionCode = selVal;
            },
            changeStatus:function (selVal) {
                this.edit_status = selVal;
            },


            getRoleList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Role/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response.data);
                    if(response.data.error == 0){
                        this.roleList = response.data.data.listRoleDTO;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            getInstitutionList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Institution/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response)=> {
                    console.log(response.data);
                    if(response.data.error == 0){
                        this.institutionList = response.data.data.listInstitution;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>


<style>

</style>
